import { format, parse } from 'date-fns';
import ru from 'date-fns/locale/ru';
import { SERVICE_TYPE_DICTIONARY } from "../../../../../../../../../TariffDetailsPage/store/constants/services";
var DESCRIPTION_CUT_VALUE = 110;
export var getIdentifier = function getIdentifier(_ref) {
  var contractNumber = _ref.contractNumber,
    id = _ref.id,
    soc = _ref.soc,
    type = _ref.type;
  var isInsurance = type === 'insurance';
  if (id) {
    return id;
  }
  if (soc && !isInsurance) {
    return soc;
  }
  if (isInsurance && soc && contractNumber) {
    return "".concat(soc).concat(contractNumber);
  }
  return '';
};
export var shouldRenderCustomServiceDetails = function shouldRenderCustomServiceDetails(_ref2) {
  var connectedDevices = _ref2.connectedDevices,
    contractNumber = _ref2.contractNumber,
    type = _ref2.type;
  return !!contractNumber || !!connectedDevices || connectedDevices === 0 || type === SERVICE_TYPE_DICTIONARY.FAVORITE_NUMBER;
};
export var formatDate = function formatDate(date) {
  var currentDate = new Date(date);
  return currentDate.toLocaleString('ru-RU', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  });
};
export var isDateInPast = function isDateInPast(date) {
  if (!date) return false;
  var currentDate = new Date();
  var formattedDate = parse(date);
  return formattedDate <= currentDate;
};
export var getTrialDate = function getTrialDate(date) {
  var parsedDate = parse(date);
  return format(parsedDate, 'D MMMM', {
    locale: ru
  });
};
export var getDateWithPromoExpiry = function getDateWithPromoExpiry(date) {
  var parsedDate = parse(date);
  return format(parsedDate, 'MMMM YYYY', {
    locale: ru
  });
};
export var shouldRenderPrice = function shouldRenderPrice(fee, nextFee) {
  return (!!fee || fee === 0) && (!!fee || fee === 0 || !!nextFee || nextFee === 0);
};
export var getIsPromoPeriodUnit = function getIsPromoPeriodUnit(promoPeriod, promoPeriodUnit) {
  return promoPeriodUnit ? "\u041F\u0440\u043E\u0431\u043D\u044B\u0435 ".concat(promoPeriod, " ").concat(promoPeriodUnit) : 'Пробный период';
};
export var cutDescriptionText = function cutDescriptionText(text) {
  if (!text) return '';
  if (text.length > DESCRIPTION_CUT_VALUE) {
    return "".concat(text.substring(0, DESCRIPTION_CUT_VALUE), "...");
  }
  return text;
};